import React, { SVGAttributes } from 'react';

export const MenuCard = (props: SVGAttributes<unknown>): JSX.Element => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
    <rect width='24' height='24' fill='none' />
    <mask id='path-1-inside-1_8352_28191' fill='white'>
      <rect x='4' y='13' width='7' height='7' rx='1.5' />
    </mask>
    <rect
      x='4'
      y='13'
      width='7'
      height='7'
      rx='1.5'
      stroke='currentColor'
      strokeWidth='4'
      mask='url(#path-1-inside-1_8352_28191)'
    />
    <mask id='path-2-inside-2_8352_28191' fill='white'>
      <rect x='4' y='4' width='7' height='7' rx='1.5' />
    </mask>
    <rect
      x='4'
      y='4'
      width='7'
      height='7'
      rx='1.5'
      stroke='currentColor'
      strokeWidth='4'
      mask='url(#path-2-inside-2_8352_28191)'
    />
    <mask id='path-3-inside-3_8352_28191' fill='white'>
      <rect x='13' y='13' width='7' height='7' rx='1.5' />
    </mask>
    <rect
      x='13'
      y='13'
      width='7'
      height='7'
      rx='1.5'
      stroke='currentColor'
      strokeWidth='4'
      mask='url(#path-3-inside-3_8352_28191)'
    />
    <mask id='path-4-inside-4_8352_28191' fill='white'>
      <rect x='13' y='4' width='7' height='7' rx='1.5' />
    </mask>
    <rect
      x='13'
      y='4'
      width='7'
      height='7'
      rx='1.5'
      stroke='currentColor'
      strokeWidth='4'
      mask='url(#path-4-inside-4_8352_28191)'
    />
  </svg>
);
